import { render, staticRenderFns } from "./Groups.vue?vue&type=template&id=65d1fb2a&scoped=true&"
import script from "./Groups.vue?vue&type=script&lang=js&"
export * from "./Groups.vue?vue&type=script&lang=js&"
import style0 from "./Groups.vue?vue&type=style&index=0&id=65d1fb2a&lang=scss&scoped=true&"
import style1 from "./Groups.vue?vue&type=style&index=1&id=65d1fb2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d1fb2a",
  null
  
)

export default component.exports